<template>
	<div ref="screen" class="big-screen">
		<div ref="content" class="content">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: "BigScreen",
	mounted() {
		this.resizeHandler();
		window.addEventListener("resize", this.resizeHandler);
		// 容器高度还会因为「数据加载后表格变宽 → 出现横向滚动条」而变化，
		// 这种情况不会触发 window resize，所以直接观察容器本身
		if (typeof ResizeObserver !== "undefined") {
			this.ro = new ResizeObserver(() => this.resizeHandler());
			this.ro.observe(this.$refs.screen);
		}
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.resizeHandler);
		if (this.ro) {
			this.ro.disconnect();
			this.ro = null;
		}
	},
	methods: {
		resizeHandler() {
			const screenWidth = this.$refs.screen.clientWidth;
			// 用容器的真实高度，而不是 100vh：出现横向滚动条时可用高度会比视口小，
			// 按 vh 算出来的内容会高出一截，被 .big-screen 的 overflow:hidden 裁掉
			// （表现为列表底部的分页、最后一行卡片看不见）
			const screenHeight = this.$refs.screen.clientHeight;
			const scale = screenWidth / 1920;
			this.$refs.content.style.transform = `scale(${scale})`;
			this.$refs.content.style.transformOrigin = "top left";
			this.$refs.content.style.width = `${1920}px`;
			this.$refs.content.style.height = `${screenHeight / scale}px`;
			this.$emit("resize", scale);
		},
	},
};
</script>

<style scoped>
.big-screen {
	width: 100%;
	height: 100%;
	overflow: hidden;
	position: relative;
}

.content {
	/* 固定宽度和自适应高度 */
	width: 1920px;
	height: 100vh; /* 高度可以根据需求调整 */
}
</style>
